import React from 'react';

function MinusSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="2"
      fill="none"
      viewBox="0 0 14 2"
    >
      <path fill="currentColor" d="M13 0H1a1 1 0 000 2h12a1 1 0 100-2z"></path>
    </svg>
  );
}

export default MinusSvg;
